export const localStorageKeys = {
  ZIP_CODE: 'zipcode',
  ZIPCODE_GEO_COORDINATES: 'zipcode_geo_coordinates',
  KITCHEN_NAMES: 'kitchenNames',
  LOGIN_INFO: 'userInfo',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  CUST_SET_ZIPCODE: 'setCustZipcode',
  CUST_SET_KITCHENS: 'setCustKitchenNames',
  CUSTINFO_API_FETCHED_TIME: 'custInfoFetchTime',
  KITCHEN_API_FETCHED_TIME: 'kitchenFetchTime',
  DEBUG_LOGOUT_POINT: 'debugLogoutPoint',
  MANAGING_BRANCH_NAME: 'managing_branch',
  URL_PROMO_CODE: 'urlPromoCode',
  URL_INFLUE_CODE: 'urlInflueCode',
  URL_REDIRECTED_FROM: 'urlRedirectFrom',
  VISITED_COUNT: 'visitedCount',
  FINGER_PRINT_USER: 'fingerPrint',
};

export const onTheMenuProductsStepper = [
  { label: 'Main course', value: 'mainCourse' },
  { label: 'Starter', value: 'starter' },
  { label: 'Dessert drinks', value: 'dessert' },
  { label: 'Kids menu', value: 'kidsMenu' },
];

export const tabs = [
  { label: 'ON THE MENU', value: 'ON THE MENU', to: '/onthemenu' },
  { label: 'PRICING', value: 'PRICING', to: 'pricing', hideOnLogin: true },
];

// Email Address regex Ref: https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/*
    Password Regex 
    Ref: https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
    Minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character
    Password should be 8 characters long, with atleast one uppercase letter, one lowercase letter, one number and one special character
  */
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const ADD_DELIVERYADDRESS_LABEL = 'Enter your delivery address';
export const ADD_DELIVERY_SUCCESSFULLY = 'Delivery address added successfully';
export const DELETE_ADDRESS_SUCCESSFULLY = 'Delivery address successfully removed';
export const DELIVERY_ADDRESS_TITLE = 'Your addresses';
export const DELIVERY_ADDRESS_SUBTITLE =
  'Delivery options and delivery speeds may vary for different location';
export const CREDIT_CARD_TITLE = 'Your payment method';
export const CREDIT_CARD_SUBTITLE = 'Your card on file';

export const API_NETWORK_ERROR = 'Network Error';
export const SERVER_DOWN_MSG_FOR_CUSTOMER = 'Please try some time, Something went wrong';
export const NO_KITCHEN_FOUND_MSG_FOR_CUSTOMER = "Sorry we don't deliver to";
export const ERROR_404_MSG = "Oops ! We're Sorry something went wrong";
export const ERROR_CATCH_BLOCK_404_MSG =
  'We apologize for the inconvenience.Something is wrong with the service, and we are currently working on resolving the issue. Please try again later.';

export const CARD_DECLINED_ERROR = 'Card declined, Please update card or try again!';
export const CARD_INAVLID_ERROR = 'Please add a valid card for payment!';
export const ZIPCODE_KITCHEN_ERROR = "Sorry, We don't find a kitchen in your zipcode at the moment";
export const ENTER_ZIPCODE_WITH_US = 'Enter Your Zipcode';
export const LOGIN_PAGE_API_ERROR = 'Something went wrong try again..';
export const CLOUD_KITCHEN_SUB_TEXT =
  'We have New menu every week, mission to cook healthy and tasty for local community';
export const CELEBRITY_CHEF_SUB_TEXT =
  'We invite best chefs from around the globe to cook for your city every week';
export const DANGEROUS_ERROR_VERBAGE = 'Sorry something went wrong please try later Ref:50089';
export const DANGEROUS_ERROR_PAYASYOUGO =
  'Sorry something went wrong please try later or contact support Ref:99910';
